import { Layer, Source } from '@vis.gl/react-maplibre';
import type { MultiPolygon } from 'geojson';
import { useEffect, useState } from 'react';

import borderShapeDe from '@/assets/border-shapes/by.json?url';
import { BEFORE_LABEL_ID } from '@/modules/BeforeLabelsId';

const BORDER_SHAPE = 'BORDER_SHAPE';

export function BorderShape() {
  const [shape, setShape] = useState<MultiPolygon>();

  useEffect(() => {
    (async () => {
      setShape(await (await fetch(borderShapeDe)).json());
    })();
  }, []);

  return shape ? (
    <Source
      key={BORDER_SHAPE}
      type="geojson"
      data={{
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [0, 90],
              [180, 90],
              [180, -90],
              [0, -90],
              [-180, -90],
              [-180, 0],
              [-180, 90],
              [0, 90],
            ],
            ...shape.coordinates[0],
          ],
        ],
      }}
    >
      <Layer
        key={BORDER_SHAPE}
        beforeId={BEFORE_LABEL_ID}
        paint={{ 'fill-color': 'black', 'fill-opacity': 0.1 }}
        type="fill"
      />
    </Source>
  ) : null;
}
